import { Div } from '../../../../base/components/native/div'
import { Img } from '../../../../base/components/native/img'
import { CENTER } from '../../../../base/helpers/style'

export const AssistantSelectorButton = () => {

    const base = Div()
    const title = Div('Happy')
    const triangle = Img('/images/triangle-icon.svg', {width: 16})
    base.append(title, triangle)

    base.cssClass({
        ...CENTER,
        alignItems: 'center',
        fontSize: '15px',
        lineHeight: '17px',
        flexDirection: 'row',
        padding: '10px 17px',
        backgroundColor: '#ECECEF',
        borderRadius: '5px',
        display: 'none',
        marginLeft: '10px',
        cursor: 'pointer',
   
    })

    return Object.assign(base, {
        setTitle: (t: string) => {
            title.el.innerText = t
        }
    })
}